import { axios } from "../../../lib/axios";


export const getPrescriptionsByPatientId = (patientId) => {
    return axios.get(`medicationrequest?patientId=${patientId}`);
}